// import { Button, Grid, Paper, TextField } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
// import React, { useState } from "react";
// import { helpers } from "../../helper/helper";
// import { useSnackbar } from "notistack";
// import { useHistory } from "react-router";

// const useStyles = makeStyles((theme) => ({
//   paper: {
//     marginTop: theme.spacing(3),
//     marginBottom: theme.spacing(3),
//     padding: theme.spacing(2),
//     [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
//       marginTop: theme.spacing(2),
//       marginBottom: theme.spacing(2),
//       padding: theme.spacing(3),
//     },
//   },
//   submit: {
//     margin: theme.spacing(4, 0, 1, 0),
//   },
//   wrapper: {
//     position: "relative",
//   },
//   buttonProgress: {
//     position: "absolute",
//     top: "50%",
//     left: "91%",
//   },
// }));

// const CreateCategory = () => {

//   const [name, setName] = useState("");
//   const classes = useStyles();
//   const history = useHistory();
//   const { enqueueSnackbar } = useSnackbar();

//   const handleChange = (e) => {
//     setName(e.target.value);
//   };

//   const handleCreateCategory = async () => {
//     const data = { name };
//     const url = 'reel/category/create';
//     const result = await helpers.apiCall("POST", url, data);
//     if (result.status === 200) {

//       setName('');
//       enqueueSnackbar("Created successfully", {
//         variant: 'success',
//         autoHideDuration: 3000,
//       });
//       history.push("/dashboard/shorts/category")
//     }
//     else {
//       enqueueSnackbar(result.data ? result.data.result.message : result.message, {
//         variant: 'error',
//         autoHideDuration: 3000,
//       });
//     }
//     setName('');
//   };

//   return (
//     <React.Fragment>
//       <Paper className={classes.paper} square>
//         <div className="card">
//           <div className="card-body">
//             <h4 className="card-title">Add Reel Category Form</h4>
//             <p className="card-description"> Add Reel Category Here </p>
//             <Grid container spacing={3}>
//               <Grid sm={12} xs={12} item>
//                 <TextField
//                   fullWidth
//                   variant="outlined"
//                   id="Category Name"
//                   name="Category Name"
//                   label="Category Name"
//                   value={name}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>
//             <Grid align="right" item style={{ marginTop: "10px" }}>
//               <div className={classes.wrapper}>
//                 <Button
//                   variant="contained"
//                   type="submit"
//                   className={classes.submit}
//                   color="primary"
//                   onClick={e => handleCreateCategory()}
//                 >
//                   Create
//                 </Button>
//               </div>
//             </Grid>
//           </div>
//         </div>
//       </Paper>
//     </React.Fragment>
//   )
// };

// export default CreateCategory;

import { Button, Grid, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { helpers } from "../../helper/helper";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(3),
    },
  },
  submit: {
    margin: theme.spacing(4, 0, 1, 0),
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "91%",
  },
  previewImage: {
    maxWidth: "100%",
    maxHeight: "200px",
    objectFit: "contain",
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: "red",
    fontSize: "12px",
    marginTop: theme.spacing(1),
  },
}));

const CreateCategory = () => {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);  // State to store the selected image
  const [imagePreview, setImagePreview] = useState(null);  // State to store image preview
  const [imageError, setImageError] = useState("");  // State for image validation error
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        // if (img.width !== 35 || img.height !== 35) {
        //   setImageError("Image must be 35x35 pixels.");
        //   setImage(null);  // Reset the image field
        //   setImagePreview(null);  // Reset image preview
        // } else {
          setImageError("");  // Clear error if the image is valid
          setImage(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagePreview(reader.result);  // Set image preview
          };
          reader.readAsDataURL(file);
        // }
      };
    }
  };

  const handleCreateCategory = async () => {
    if (!image) {
      enqueueSnackbar("Please upload a valid image", { variant: "error", autoHideDuration: 3000 });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    if (image) {
      formData.append("reel_catgeory_image", image);  // Append the image file to the form data
    }

    const url = "reel/category/create";
    const result = await helpers.apiCallForm("POST", url, formData);

    if (result.status === 200) {
      setName("");
      setImage(null);  // Reset image field after successful creation
      setImagePreview(null);  // Reset image preview
      enqueueSnackbar("Created successfully", {
        variant: "success",
        autoHideDuration: 3000,
      });
      history.push("/dashboard/shorts/category");
    } else {
      enqueueSnackbar(result?.data ? result.data?.result?.message : result?.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} square>
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Add Reel Category Form</h4>
            <p className="card-description"> Add Reel Category Here </p>
            <Grid container spacing={3}>
              <Grid sm={12} xs={12} item>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="Category Name"
                  name="Category Name"
                  label="Category Name"
                  value={name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid sm={12} xs={12} item>
                <input
                  accept="image/*"  // Allow only image files
                  type="file"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                  id="image-upload"
                />
                <label htmlFor="image-upload">
                  Upload Image <span style={{ color: "red" }}>*</span>
                  <Button variant="contained" className="ml-2" component="span" color="primary">
                    Upload
                  </Button>
                </label>
              </Grid>

              {/* Image Preview */}
              {imagePreview && (
                <Grid sm={12} xs={12} item>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className={classes.previewImage}
                  />
                </Grid>
              )}

              {/* Error message for invalid image size */}
              {imageError && (
                <Grid sm={12} xs={12} item>
                  <div className={classes.errorText}>{imageError}</div>
                </Grid>
              )}
            </Grid>
            <Grid align="right" item style={{ marginTop: "10px" }}>
              <div className={classes.wrapper}>
                <Button
                  variant="contained"
                  type="submit"
                  className={classes.submit}
                  color="primary"
                  onClick={handleCreateCategory}
                >
                  Create
                </Button>
              </div>
            </Grid>
          </div>
        </div>
      </Paper>
    </React.Fragment>
  );
};

export default CreateCategory;
